import { GoogleSource } from '../../types';
import { isDatadogSyntheticTest } from '../datadog';
import initGoogleTagManager from './initGoogleTagManager.script';

export interface GoogleTagManagerConfig {
  id: string;
}

const isInitialized = (): boolean =>
  typeof window !== 'undefined' && window.gtag && !isDatadogSyntheticTest();

export default {
  initialize: (props) => {
    initGoogleTagManager(props.id);
  },
  trackPageView: (props) => {
    if (!isInitialized()) return;
    window.gtag('event', 'page_view', props);
  },
  trackPurchase: (props) => {
    if (!isInitialized()) return;
    window.gtag('event', 'purchase', props);
  },
  trackGoogleEvent: (eventName, context) => {
    if (!isInitialized()) return;
    window.gtag('event', eventName, context);
  },
} as GoogleSource<GoogleTagManagerConfig>;
